/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-tabs */
/* eslint-disable max-len */
import _ from 'lodash';
import api from '../../utils/api';
import { API_BASE_URL, ENV_TYPE } from '../../../config';
import { errorMessage, successMessage } from '../../utils/message';
import {
  setCookie, setRallyClose, getRallyClose, change, isInput, bestRecordValiChk,
  incheckRequired, checkRequired, checkcode, emailChange, birthList, courseList,
  setupAddressMapKakao, countryArr,
  noRecordCheck, checkLength, showSucces, dateErrorCheck, checkEmail,
  courseSeqArr, validationArr, getCookie, Mobile, deleteCookie, chkJuminNum, checkRegex, setValidationArr,
  showError, PERIODS, serverDate, checkPasswordConf,
} from '../../utils/common';

let nationDivide = 'local'; // 내국인, 외국인 value 구분
let agreeData = ''; // 참가자 동의 json 데이터
let {
  phtel, phtelelement, emtel, emelement, uniqNumber,
} = ''; // 내국인, 외국인 구별 데이터
let freeCodeConf = 'none'; // 무료 코드 판별
let choMemberConf = null; // 조선닷컴 회원 인증 여부 판별
let deariConf = true; // 법정 대리인 동의 판별
let bloodConf = ''; // 혈액형 구분
let subYn = 'N'; // 조선일보 무료구독 신청
let receiveType = 'C'; // 물품 수령방법 데이터
let finRecord = ''; // 최고기록 데이터
let usernameGap = ''; // 국내참가자 이름 공백 전체 제거
let postnumberGap = ''; // 외국인참가자 우편번호 공백 전체 제거
let payPrice; // 가격 데이터
let courseConf = true; // 하프코스 신청 제한 데이터
const groupSeq = 1; // 그룹 시퀀스 데이터

const local = document.getElementById('local');
const foreigner = document.getElementById('foreigner');
const size = document.getElementById('size');
const particle = document.getElementById('particle');
const username = document.getElementById('username');
const userenname = document.getElementById('user_en_name');
const nationality = document.getElementById('nationality');
const year = document.getElementById('year');
const month = document.getElementById('month');
const day = document.getElementById('day');
const password = document.getElementById('password');
const passwordConf = document.getElementById('passwordConf');
const blood = document.getElementById('blood');
const bloodEtc = document.getElementById('bloodEtc');
const email = document.getElementById('email');
const emailBehind = document.getElementById('emailBehind');
const post = document.getElementById('post');
const address1 = document.getElementById('address_kakao');
const address2 = document.getElementById('address_detail');
const phfrontNumber = document.getElementById('ph_front_number');
const phoneNumber = document.getElementById('phoneNumber');
const enPhoneNumber = document.getElementById('EnPhoneNumber');
const emfrontNumber = document.getElementById('em_front_number');
const emerNumber = document.getElementById('emerNumber');
const enEmerNumber = document.getElementById('enEmerNumber');
const subscribe = document.getElementById('subscribe');
const freecode = document.getElementById('free_code');
const freecodeForm = document.getElementById('free_code_form');
const chosunEmail = document.getElementById('member_id');
const emailpassword = document.getElementById('member_pw');
const foreNumber = document.getElementById('foreNumber');
const emailBehindSelect = document.getElementById('emailBehindSelect');
const resNumber = document.getElementById('resNumber1');
const resNumber2 = document.getElementById('resNumber2');
const deari = document.getElementById('deari');
const deariParentName = document.getElementById('parentName');
const deariCellNo = document.getElementById('cellNo');
const deariParentAgr = document.getElementById('parentAgr');
const deariAgrDate = document.getElementById('agrDate');
const deariMessage = document.getElementById('deariMessage');
const deariOk = document.getElementById('deariOk');
const deariMessageEn = document.getElementById('deariMessageEn');
const deariOkEn = document.getElementById('deariOkEn');
const targetHour = document.getElementById('targetHour');
const targetMin = document.getElementById('targetMin');
const targetSec = document.getElementById('targetSec');
const targetDate = document.getElementById('targetDate');
const targetName = document.getElementById('targetName');
const modalConfirm = document.getElementById('modalConfirm');
const modalElement = document.querySelector('.modalWrap2');
const freeCho = document.getElementById('free_cho');
const deariBtn = document.getElementById('deariBtn');
const choMemberBtn = document.getElementById('choMember_btn');
const kakao = document.getElementById('kakao');
const noRecord = document.getElementById('no_record');
const applyCloseBtn = document.getElementById('applyCloseBtn');
const freeBtnCheck = document.getElementById('freeBtnCheck');
const joinApply = document.getElementById('joinApply');
const actionApply = document.getElementById('actionApply');

const confirmCiDiCallback = (e) => {
  document.getElementById('parentName').value = e.data.parentName;
  document.getElementById('cellNo').value = e.data.cellNo;
  document.getElementById('parentAgr').value = e.data.parentAgr;
  document.getElementById('agrDate').value = e.data.agrDate;

  deariBtn.style.backgroundColor = '#eaeaea';
  deariBtn.style.color = '#999';
  deariBtn.style.border = '1px solid #d7d7d7';
  deariBtn.textContent = '법정대리인 동의 완료';
  deariBtn.disabled = true;

  year.disabled = true;
  month.disabled = true;
  day.disabled = true;

  deariMessage.style.display = 'none';
  deariMessageEn.style.display = 'none';
  deariOk.style.display = 'block';
  deariOkEn.style.display = 'block';

  if (document.getElementById('parentName').value !== '' && document.getElementById('cellNo').value !== '') {
    deariConf = true;
  }
};

// 입력폼 초기화 세팅
function initializeForm() {
  nationality.disabled = true;
  nationality.value = 'South Korea';
  post.disabled = true;
  address1.disabled = true;
  resNumber.disabled = true;
  change('ko');
}

function nationList() {
  const nationalitySelect = document.getElementById('nationality');
  nationalitySelect.innerHTML = '';
  nationality.innerHTML = '<option value="">Selection</option>';
  if (document.querySelector("#nationality option[value='South Korea']")) {
    document.querySelector("#nationality option[value='South Korea']").remove();
  }
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < countryArr.length; i++) {
    const option = document.createElement('option');
    const country = countryArr[i];
    if (country === 'South Korea' && nationDivide === 'local') {
      option.value = country;
      option.textContent = '대한민국';
    } else {
      option.value = country;
      option.textContent = country;
    }

    if (nationalitySelect) {
      nationalitySelect.appendChild(option);
    }
  }
}

function checkForeignerAddress() {
  if (nationDivide === 'foreigner' && post.value && address1.value) {
    isInput(nationDivide, post);
  }
}

function addChangeListener(element, callback) {
  if (element) {
    element.addEventListener('change', callback);
  }
}

// 법정 대리인 동의 초기화
function deariCheck() {
  deariConf = true;

  deari.style.display = 'none';

  deariBtn.style.backgroundColor = '#fff';
  deariBtn.style.color = '#000';
  deariBtn.style.border = '1px solid #000';
  deariBtn.textContent = '법정대리인 동의 받기';
  deariBtn.disabled = false;

  year.disabled = false;
  month.disabled = false;
  day.disabled = false;
}

// 조선일보 무료구독 신청 체크 여부
freeCho.addEventListener('change', () => {
  if (freeCho.checked) {
    subYn = 'Y';
  } else {
    subYn = 'N';
  }
});

// 핸드폰 번호 & 비상연락망 비교
function phoneCheckHandler(main, emergency) {
  return () => {
    isInput(nationDivide, main);
    checkLength(nationDivide, main, 8);
    if (main.value && emergency.value && main.value === emergency.value) {
      alert('핸드폰 번호와 비상연락망은 다르게 입력해주세요.');
      // eslint-disable-next-line no-param-reassign
      main.value = '';
    }
  };
}

// 언어별 세팅 체크
function nationCheck() {
  if (nationDivide === 'local') {
    uniqNumber = `${resNumber.value}-${resNumber2.value}`;
    phtelelement = phoneNumber;
    phtel = phfrontNumber.value + phoneNumber.value;
    emelement = emerNumber;
    emtel = emfrontNumber.value + emerNumber.value;
  } else {
    uniqNumber = foreNumber.value;
    phtelelement = enPhoneNumber;
    phtel = enPhoneNumber.value;
    emelement = enEmerNumber;
    emtel = enEmerNumber.value;
  }
}

// 내외국인 탭 설정
function setupTab(isLocal) {
  nationDivide = isLocal ? 'local' : 'foreigner';
  setCookie('divide_json_data', nationDivide, 1);

  // Validation 탭 클릭시 취소
  incheckRequired(isLocal
    ? [username, password, nationality, year, month, day, particle, size, blood, phoneNumber, emerNumber, post, address1, email, emailBehindSelect, freecode, subscribe]
    : [username, password, nationality, year, month, day, particle, size, blood, enPhoneNumber, enEmerNumber, post, address1, email, emailBehind, freecode, subscribe]);

  // 혈액형 옵션 설정
  blood.innerHTML = isLocal
    ? `
  										<option value="">선택</option>
  										<option lang="ko" value="RH+O">O형</option>
  										<option lang="ko" value="RH+A">A형</option>
  										<option lang="ko" value="RH+B">B형</option>
  										<option lang="ko" value="RH+AB">AB형</option>
  										<option lang="ko" value="etc">직접 입력</option>
  								`
    : `
  										<option value="">Selection</option>
  										<option lang="en" value="RH+O">O Type</option>
  										<option lang="en" value="RH+A">A Type</option>
  										<option lang="en" value="RH+B">B Type</option>
  										<option lang="en" value="RH+AB">AB Type</option>
  										<option lang="en" value="etc">Direct input</option>
  								`;

  // 공통 함수 호출
  deariCheck();
  courseList(nationDivide, 'normal');

  // 무료코드 입력 후 다른탭 클릭시 disabled 해제
  if (freecode.disabled) {
    freecode.disabled = false;
  }

  // 국가 관련 설정
  if (isLocal) {
    nationality.innerHTML = '<option value="South Korea">대한민국</option>';
    nationality.disabled = true;
    nationality.value = 'South Korea';
    post.disabled = true;
    address1.disabled = true;
    resNumber.disabled = true;
  } else {
    nationList();
    nationality.disabled = false;
    nationality.value = '';
    post.disabled = false;
    address1.disabled = false;
    resNumber.disabled = false;
  }

  // 이메일 관련 설정
  emailBehind.disabled = false;
  emailBehind.value = '';
  emailBehindSelect.value = '';
  const emailOption = document.querySelector('#emailBehindSelect option[value=""]');
  if (emailOption) {
    emailOption.textContent = isLocal ? '직접 입력' : 'Direct Input';
  }

  // 생년월일 placeholder 변경
  const yearOption = document.querySelector('#year option[value=""]');
  if (yearOption) {
    yearOption.textContent = isLocal ? '년도' : 'Year';
  }

  const monthOption = document.querySelector('#month option[value=""]');
  if (monthOption) {
    monthOption.textContent = isLocal ? '월' : 'Month';
  }

  const dayOption = document.querySelector('#day option[value=""]');
  if (dayOption) {
    dayOption.textContent = isLocal ? '일' : 'Day';
  }

  // 탭 색상 설정
  if (isLocal) {
    local.style.color = '#fff';
    local.style.backgroundColor = '#000';
    foreigner.style.color = '#000';
    foreigner.style.backgroundColor = '#fff';
    freecodeForm.style.borderBottom = '1px solid #eaeaea';
  } else {
    local.style.color = '#000';
    local.style.backgroundColor = '#fff';
    foreigner.style.color = '#fff';
    foreigner.style.backgroundColor = '#000';
    freecodeForm.style.borderBottom = '0';
  }

  // 성별 텍스트 설정
  const genderM = document.querySelector('input[id="gender_m"]');
  if (genderM && genderM.nextElementSibling) {
    genderM.nextElementSibling.textContent = isLocal ? '남성' : 'Male';
  }

  const genderW = document.querySelector('input[id="gender_w"]');
  if (genderW && genderW.nextElementSibling) {
    genderW.nextElementSibling.textContent = isLocal ? '여성' : 'Female';
  }

  // 언어 설정 클래스 토글
  const halfmarathon = document.getElementById('halfmarathon');
  if (halfmarathon) {
    halfmarathon.classList.toggle('lang_ko', isLocal);
    halfmarathon.classList.toggle('lang_en', !isLocal);
  }

  change(isLocal ? 'ko' : 'en');

  // 선택 항목 초기화
  subscribe.value = '';
  document.getElementById('cho_subscribe_form').style.display = 'none';
  chosunEmail.value = '';
  emailpassword.value = '';
  bloodEtc.value = '';
  bloodEtc.disabled = true;

  // 모달 버튼 초기화
  modalConfirm.style.color = '#000';
  modalConfirm.style.background = '#fff';
  modalConfirm.style.border = '1px solid #000';
  modalConfirm.disabled = false;
  document.getElementById('modalConfirm').textContent = '인증하기';
}

const applyFn = {
  dateCheck() {
    const yearValue = document.getElementById('year').value;
    const monthValue = document.getElementById('month').value;
    const dayValue = document.getElementById('day').value;

    if (yearValue && monthValue && dayValue) {
      const userBirthDate = new Date(`${yearValue}-${monthValue}-${dayValue}`);
      // 법정 대리인 나이 판별
      const referenceDateDeari = new Date('2011-04-27');
      const minimumBirthDate = new Date('2007-04-27');
      const isDisplay = true;

      if (userBirthDate > referenceDateDeari) {
        deari.style.display = 'flex';
        deariMessage.style.display = isDisplay ? 'block' : 'none';
        deariMessageEn.style.display = isDisplay ? 'block' : 'none';
        deariOk.style.display = isDisplay ? 'none' : 'block';
        deariOkEn.style.display = isDisplay ? 'none' : 'block';
        deariConf = false;
      } else {
        deari.style.display = 'none';
        deariConf = true;
      }

      isInput(nationDivide, document.getElementById('year'));

      // Check underage condition
      const isUnderage = userBirthDate < minimumBirthDate;

      if (PERIODS.half.normal.open < serverDate() && PERIODS.half.normal.close > serverDate()) {
        if (!isUnderage) {
          alert(errorMessage.apply.half);
          document.getElementById('year').value = '';
          document.getElementById('month').value = '';
          document.getElementById('day').value = '';
          deari.style.display = 'none';
          courseConf = false;
        } else {
          courseConf = true;
        }
      }
    }
  },

  // 신청하기 이전 버튼 이벤트
  preActionApply() {
    deleteCookie('agree_json_data');
    location.href = '../apply/part-agree.html';
  },

  // 보험가입 페이지 이전 버튼 이벤트
  preActionJoin() {
    setValidationArr();
    document.querySelector('.part_apply').style.display = 'block';
    document.querySelector('.part_join').style.display = 'none';
  },

  maxLengthCheck(data) {
    if (data.value.length > data.maxLength) {
      // eslint-disable-next-line no-param-reassign
      data.value = data.value.slice(0, data.maxLength);
    }
  },
};

export default applyFn;

window.applyFn = applyFn;

// tab link disable
function disableClick(event) {
  event.preventDefault();
}

document.addEventListener('DOMContentLoaded', async () => {
  // // 참가신청 마감
  // if (!isAllowed) {
  //   window.location.href = '../etc/finish.html';
  //   return;
  // }

  // // 준비중
  // if (!inRange1 && !inRange2) {
  //   window.location.href = '../etc/ready.html';
  //   return;
  // }

  try {
    const mainData = await api.mainLoad();
    setCookie('rallyGnbDate', mainData, 1);
    setRallyClose(mainData);
  } catch (error) {
    console.error('mainLoad 실패:', error);
  }

  setCookie('divide_json_data', nationDivide, 1);

  // 코스, 생년월일, 국가, 티셔츠 사이즈 리스트 불러오기
  courseList(nationDivide, 'normal');
  birthList();
  nationList();

  // 기본 설정값
  initializeForm();

  blood.innerHTML = `
                    <option value="">선택</option>
                    <option lang="ko" value="RH+O">O형</option>
                    <option lang="ko" value="RH+A">A형</option>
                    <option lang="ko" value="RH+B">B형</option>
                    <option lang="ko" value="RH+AB">AB형</option>
                    <option lang="ko" value="etc">직접 입력</option>
                `;

  // 내국인 탭 클릭 이벤트
  local.addEventListener('click', (e) => {
    setupTab(true);
    return disableClick(e);
  });

  foreigner.addEventListener('click', (e) => {
    setupTab(false);
    return disableClick(e);
  });

  // 조선닷컴 회원 인증 모달창 활성화
  modalConfirm.addEventListener('click', () => {
    modalElement.style.display = 'block';
    document.body.classList.add('modal-open');
  });

  const handleMemberClick = _.throttle(async () => {
    const result = await api.memberCheck(getRallyClose().seq, chosunEmail.value, emailpassword.value);
    if (result) {
      alert(successMessage.auth.auth);
      modalElement.style.display = 'none';
      document.body.classList.remove('modal-open');
      modalConfirm.style.color = '#999999';
      modalConfirm.style.background = '#d7d7d7';
      modalConfirm.style.border = '0px';
      modalConfirm.disabled = true;
      modalConfirm.textContent = '인증완료';
      choMemberConf = chosunEmail.value;
    } else {
      alert(errorMessage.auth.impossible);
      chosunEmail.value = '';
      emailpassword.value = '';
    }
  }, 2000);

  choMemberBtn.addEventListener('click', handleMemberClick);

  const handleKakaoClick = _.throttle(() => {
    const detail = document.querySelector('input[name=address_detail]');
    setupAddressMapKakao(nationDivide, post, address1, detail);
  }, 1000);

  kakao.addEventListener('click', handleKakaoClick);

  emailBehindSelect.addEventListener('change', (e) => {
    emailChange(emailBehind, e.target.value);
  });

  post.addEventListener('change', checkForeignerAddress);
  address1.addEventListener('change', checkForeignerAddress);

  noRecord.addEventListener('change', () => {
    noRecordCheck(targetHour, targetMin, targetSec, targetDate, targetName);
  });

  // 조선일보 무료구독 신청 체크 여부
  freeCho.addEventListener('change', () => {
    if (freeCho.checked) {
      subYn = 'Y';
    } else {
      subYn = 'N';
    }
  });

  username.addEventListener('change', () => {
    isInput(nationDivide, username);
    checkRegex(nationDivide, username);
    document.querySelector('input[name="join_id"]').value = username.value;
  });

  password.addEventListener('change', () => {
    isInput(nationDivide, password);
    checkLength(nationDivide, password, 8);
    checkPasswordConf(nationDivide, passwordConf, password);
  });

  passwordConf.addEventListener('change', () => {
    isInput(nationDivide, password);
    checkLength(nationDivide, password, 8);
    checkPasswordConf(nationDivide, password, passwordConf);
  });

  particle.addEventListener('change', () => {
    isInput(nationDivide, particle);
    const coursePrices = {
      3: courseSeqArr.half.price,
      4: courseSeqArr.halfsub.price,
      5: courseSeqArr.ten.price,
      6: courseSeqArr.tensub.price,
    };
    payPrice = coursePrices[particle.value] || 0;
  });

  subscribe.addEventListener('change', () => {
    isInput(nationDivide, subscribe);
    const form = document.getElementById('cho_subscribe_form');
    console.log('qwe');
    if (subscribe.value && subscribe.value !== '조선일보') {
      form.style.display = 'block';
    } else {
      form.style.display = 'none';
      freeCho.checked = false;
    }
  });

  emailBehindSelect.addEventListener('change', () => {
    emailBehind.disabled = !!emailBehindSelect.value;
  });

  blood.addEventListener('change', () => {
    if (blood.value === 'etc') {
      bloodEtc.disabled = false;
      showSucces(blood);
    } else {
      bloodEtc.value = '';
      bloodEtc.disabled = true;
      showSucces(blood);
      if (blood.value) showSucces(bloodEtc);
    }
    bloodConf = blood.value;
  });

  resNumber2.addEventListener('change', () => {
    if (nationDivide === 'local') {
      checkRequired(nationDivide, [resNumber, resNumber2]);
      chkJuminNum(nationDivide, resNumber.value, resNumber2.value);
    } else {
      checkRequired(nationDivide, [foreNumber]);
    }
  });

  foreNumber.addEventListener('change', () => {
    isInput(nationDivide, foreNumber);
  });

  applyCloseBtn.addEventListener('click', () => {
    modalElement.style.display = 'none';
    document.body.classList.remove('modal-open');
  });

  // 날짜 요소 이벤트 등록
  ['year', 'month', 'day'].forEach((key) => {
    const el = document.getElementById(key);
    addChangeListener(el, () => {
      isInput(nationDivide, el);
      const dateStr = `${year.value}${month.value}${day.value}`;
      dateErrorCheck(nationDivide, year, dateStr);
    });
  });

  addChangeListener(phoneNumber, phoneCheckHandler(phoneNumber, emerNumber));
  addChangeListener(emerNumber, phoneCheckHandler(emerNumber, phoneNumber));
  addChangeListener(enPhoneNumber, phoneCheckHandler(enPhoneNumber, enEmerNumber));
  addChangeListener(enEmerNumber, phoneCheckHandler(enEmerNumber, enPhoneNumber));

  // 이메일
  addChangeListener(email, () => {
    isInput(nationDivide, email);
    checkEmail(nationDivide, email, emailBehind);
  });

  addChangeListener(emailBehind, () => {
    isInput(nationDivide, emailBehind);
    checkEmail(nationDivide, email, emailBehind);
  });

  addChangeListener(emailBehindSelect, () => {
    checkEmail(nationDivide, email, emailBehind);
    if (emailBehindSelect.value) showSucces(emailBehind);
  });

  // 단일 입력 체크 요소
  [
    nationality,
    bloodEtc,
    size,
  ].forEach((el) => {
    addChangeListener(el, () => {
      isInput(nationDivide, el);
    });
  });

  // 무료코드
  addChangeListener(freecode, () => {
    freeCodeConf = freecode.value ? false : 'none';
    if (!freecode.value) showSucces(freecode);
  });

  // 목표 기록 체크
  [targetHour, targetMin, targetSec, targetDate, targetName].forEach((el) => {
    addChangeListener(el, () => {
      bestRecordValiChk(nationDivide, targetHour, targetMin, targetSec, targetDate, targetName);
    });
  });

  // 법정대리인 체크
  const handleDeariClick = _.throttle(() => {
    window.addEventListener('message', confirmCiDiCallback, false);
    window.open(
      `${API_BASE_URL}/auth?env=${ENV_TYPE}&rallyType=H`,
      'winpopup',
      'width=400, height=630, resizable=1, scrollbars=no, status=0, titlebar=0, toolbar=0, left=300, top=200',
    );
  }, 2000);

  const handleFreeClick = _.throttle(async () => {
    const isFreeCode = await api.freeCheck(freecode.value);
    if (isFreeCode) {
      alert(successMessage.code);
      freeCodeConf = 'keep_code';
      freecode.disabled = true;
      showSucces(freecode);
    } else if (!freecode.value) {
      alert(errorMessage.apply.code.input);
    } else {
      const msg = nationDivide === 'foreigner'
        ? errorMessage.apply.code.en
        : errorMessage.apply.code.ko;

      alert(msg);
      freeCodeConf = false;
      showError(freecode, msg);
    }
  }, 2000);

  // 신청하기 다음 버튼 이벤트
  const handleActionClick = _.throttle(async () => {
    nationCheck([nationDivide, `${resNumber.value}-${resNumber2.value}`, phoneNumber, phfrontNumber.value + phoneNumber.value, emerNumber.value, emfrontNumber.value + emerNumber.value]);

    if (nationDivide === 'foreigner') {
      usernameGap = username.value;
      postnumberGap = post.value.replace(/ /g, '');
    } else {
      usernameGap = username.value.trim();
      postnumberGap = post.value;
    }

    if (!(password.value === passwordConf.value)) {
      alert(errorMessage.apply.password);

      return;
    }

    const requiredFields = [
      username, nationality, year, password, passwordConf, particle, size, blood, email, post, phtelelement, emelement,
    ];

    const fieldsToCheck = nationDivide === 'foreigner'
      ? requiredFields
      : [...requiredFields, subscribe];
    if (blood.value === 'etc') fieldsToCheck.push(bloodEtc);
    checkRequired(nationDivide, fieldsToCheck);
    checkcode(nationDivide, freecode, freeCodeConf);

    if (validationArr.length > 0) {
      document.getElementById(validationArr[0]).focus();
    } else if (courseConf === false) {
      alert(errorMessage.apply.half);
    } else if (!deariConf) {
      if (!document.getElementById('parentName').value || !document.getElementById('cellNo').value) {
        alert(errorMessage.deari);
        document.getElementById('year').focus();
      }
    } else {
      setValidationArr();
      const setBirth = year.value + month.value + day.value;
      const result = await api.duplicateMemberCheck(getRallyClose().seq, username.value, setBirth, `${email.value.trim()}@${emailBehind.value.trim()}`);
      if (result) {
        const resNumberMerge = setBirth.substring(2, 8);

        document.querySelector('input[name="res"]').value = resNumberMerge;
        document.querySelector('.part_apply').style.display = 'none';
        document.querySelector('.part_join').style.display = 'block';
      }
    }
  }, 2000);

  // 보험 가입 페이지 다음 버튼 이벤트
  const handleJoinClick = _.throttle(async () => {
    agreeData = getCookie('agree_json_data');

    nationCheck([nationDivide, `${resNumber.value}-${resNumber2.value}`, phoneNumber.value, phfrontNumber.value + phoneNumber.value, emerNumber.value, emfrontNumber.value + emerNumber.value]);

    if (nationDivide === 'local') {
      checkRequired(nationDivide, [resNumber, resNumber2]);

      chkJuminNum(nationDivide, resNumber.value, resNumber2.value);
    } else {
      checkRequired(nationDivide, [foreNumber]);
    }

    if (blood.value === 'etc') {
      bloodConf = bloodEtc.value;
      checkRequired(nationDivide, [bloodEtc]);
    }

    if (nationDivide === 'local') {
      receiveType = 'C';
    } else {
      const pickup = document.querySelector('input[type="radio"][name="pickup"]:checked');
      const pickupValue = pickup ? pickup.value : null;
      receiveType = pickupValue;
    }

    finRecord = '00:00:00';

    if (validationArr.length > 0) {
      document.getElementById(validationArr[0]).focus();
    } else {
      setCookie('divide_json_data', nationDivide, 1);

      setValidationArr();

      const paymentDetails = freeCodeConf === 'keep_code'
        ? {
          payMethod: 'Coupon', price: 0, payState: 1, codeNumber: freecode.value,
        }
        : {
          payMethod: 'Card', price: payPrice, payState: 0, codeNumber: null,
        };

      const genderInput = document.querySelector('input[type="radio"][name="gender"]:checked');
      const genderValue = genderInput ? genderInput.value : null;

      // applyMemberData 기본 구성
      const applyMemberData = {
        rallySeq: getRallyClose().seq,
        groupSeq,
        giftSeq: size.value,
        courseSeq: particle.value,
        name: usernameGap,
        eName: userenname.value,
        nation: nationality.value,
        birth: year.value + month.value + day.value,
        gender: genderValue,
        password: password.value,
        blood: bloodConf,
        email: `${email.value}@${emailBehind.value}`,
        post: postnumberGap,
        address1: address1.value,
        address2: address2.value,
        receiveType,
        pTel: phtel,
        eTel: emtel,
        subscribe: subscribe.value,
        subscribeYn: subYn,
        chosunEmail: choMemberConf,
        payType: 'Direct',
        payMethod: paymentDetails.payMethod,
        price: paymentDetails.price,
        payState: paymentDetails.payState,
        codeNumber: paymentDetails.codeNumber,
        personalNumber: uniqNumber,
        device: Mobile(),
        agr1: agreeData.agr1,
        agr2: agreeData.agr2,
        agr3: agreeData.agr3,
        agr4: agreeData.agr4,
        agr5: agreeData.agr5,
        parentInfo: {
          parentName: deariParentName.value,
          cellNo: deariCellNo.value,
          parentAgr: deariParentAgr.value,
          agrDate: deariAgrDate.value,
        },
        bestRecord: finRecord,
        bestRecordName: '', // 초기값
        bestRecordDate: '', // 초기값
        targetRecord: '00:00:00', // 초기값
      };

      const result = await api.applyMember(applyMemberData);

      if (result) {
        alert(successMessage.apply.complete);
        location.href = freeCodeConf === 'keep_code' ? '../apply/part-complete.html' : '../apply/part-pay.html';
      }
    }
  }, 2000);

  freeBtnCheck.addEventListener('click', handleFreeClick);
  actionApply.addEventListener('click', handleActionClick);
  joinApply.addEventListener('click', handleJoinClick);
  deariBtn.addEventListener('click', handleDeariClick);
});
